<div class="category-picker">
  <button class="back-btn" (click)="goBack()" [attr.aria-label]="currLang === 'ar' ? 'رجوع' : 'Back'">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <h2 class="picker-title">
    {{ currLang === 'ar' ? 'اختر نوع اللعبة' : 'Pick a game category' }}
  </h2>

  <div class="category-grid">
    <button class="category-card category-card--trivia" type="button" (click)="pickTrivia()">
      <div class="category-icon" aria-hidden="true">
        <span>📚</span>
        <span>🧠</span>
        <span>🔬</span>
      </div>
      <div class="category-name">
        {{ currLang === 'ar' ? 'الألغاز' : 'Trivia' }}
      </div>
      <div class="category-sub">
        {{ currLang === 'ar' ? 'أسئلة بحسب المادة' : 'Quiz by subject' }}
      </div>
    </button>

    <button class="category-card category-card--academic" type="button" (click)="pickAcademic()">
      <div class="category-icon" aria-hidden="true">
        <span>🎓</span>
        <span>📐</span>
        <span>🔢</span>
      </div>
      <div class="category-name">
        {{ currLang === 'ar' ? 'ألعاب المهارات' : 'Academic Skill Games' }}
      </div>
      <div class="category-sub">
        {{ currLang === 'ar' ? 'تعلّم بحسب المادة' : 'Learn by subject' }}
      </div>
    </button>

    <button class="category-card category-card--fun" type="button" (click)="pickFunGames()">
      <div class="category-icon" aria-hidden="true">
        <span>🎳</span>
        <span>🎯</span>
        <span>🕹️</span>
      </div>
      <div class="category-name">
        {{ currLang === 'ar' ? 'ألعاب ممتعة' : 'Fun Games' }}
      </div>
      <div class="category-sub">
        {{ currLang === 'ar' ? 'العب واستمتع' : 'Play and have fun' }}
      </div>
    </button>
  </div>
</div>
